import React from 'react';
import { Button, Row, Col, Tooltip } from 'antd';
import {
  EyeOutlined,
  HistoryOutlined,
} from '@ant-design/icons';

import { CustomTable, GeneralContainer } from '../../../../components';
import { ShareResponse } from '../../../../share';
import SearchRow from '../components/Filters';
import CustomAlert from '../../../../components/CustomAlert/CustomAlert';
import { GoodsResponse } from '../../../WarehouseView/types';

interface RequesedItemsViewProps {
  data?: GoodsResponse;
  onPagination: (page: number, pageSize: number) => void;
  onViewDetail: (id: string) => void;
  onManageDetail: (id: string) => void;
  formik: any;
  states?: ShareResponse[];
  isLoading: boolean;
  onResetFilters: () => void;
  setIsModalCustomFilter?: any;
}

const RequesedItemsView: React.FC<RequesedItemsViewProps> = ({
  data,
  onManageDetail,
  onViewDetail,
  onPagination,
  formik,
  states,
  isLoading,
  onResetFilters,
}) => {

  const columns = [
    {
      title: 'Código del elemento',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: true,
      align: 'center',
      render: (_: string, record: any) => !record.description  ? 'N/A' : record.plate_code ?? record.item_code,
    },
    {
      title: 'Tipo de elemento',
      dataIndex: 'item_type',
      key: 'item_type',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
      render: (text: string) => text || 'N/A'
    },
    {
      title: 'Artículo',
      dataIndex: 'item',
      key: 'item',
      sorter: true,
      align: 'center',
      render: (_: string, record: any) => record.item_code ? record.item_code + ' - ' + record.item : 'N/A',
      responsive: ['lg'],
    },
    {
      title: 'Solicitante',
      dataIndex: 'requester',
      key: 'requester',
      sorter: true,
      align: 'center',
      render: (_: string, record: any) => record.requester_document + ' - ' + record.requester,
      responsive: ['lg'],
    },
    {
      title: 'Número de ticket',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Fecha de solicitud',
      dataIndex: 'query_date',
      key: 'query_date',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      key: 'regional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Seccional',
      dataIndex: 'sectional',
      key: 'sectional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Estado bien',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status: string) => {
        return <CustomAlert status={status} />
      },
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (value: any) => (
        <>
          {value.petition_status_id === 9 ? 
            <Tooltip title="Gestionar solicitud">
              <Button
                type="link"
                icon={<HistoryOutlined />}
                onClick={() => onManageDetail(String(value.petition_id))}
              />
            </Tooltip> :
            <Tooltip title="Ver solicitud">
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => onViewDetail(String(value.petition_id))}
              />
            </Tooltip>
          }
        </>
      ),
    },
  ];

  return (
    <GeneralContainer title="Elementos solicitados" isLoading={isLoading}>
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24}>
          <SearchRow
            formik={formik}
            states={states}
            onCancel={onResetFilters}
            isLoading={isLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
            <CustomTable
              loading={isLoading}
              columns={columns as any}
              dataSource={data?.data || []}
              paginationConfig={{
                current: data?.current_page,
                pageSize: data?.per_page,
                total: data?.total,
                onChange: onPagination,
              }}
              scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
    </GeneralContainer>
  );
};

export default RequesedItemsView;
